import { Component } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AssetsPipe } from '@pipes/assets.pipe';

import { ConfigService } from '../../../services/config.service';
import { TopicvizService } from '../../../services/topicviz/topicviz.service';
import { SearchPixabayPictureModalComponent } from '../search-pixabay-picture-modal/search-pixabay-picture-modal.component';

@Component({
  selector: 'app-edit-cluster-modal',
  templateUrl: './edit-cluster-modal.component.html',
  styleUrls: ['./edit-cluster-modal.component.scss'],
})
export class EditClusterModalComponent {
  public clusters = [];
  public selectedCluster = null;
  public requestInProgress = false;
  public keywordObjects = [];
  private hasChanges = false;

  setClusters(clusters, selectedClusterIndex = 0) {
    if (clusters.length > 0) {
      this.onSelectCluster(clusters[selectedClusterIndex]);
    }
    this.clusters = clusters;
  }

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private topicvizService: TopicvizService,
    private appConfig: ConfigService,
    private assetsPipe: AssetsPipe,
  ) {}

  getTopClusterWord(cluster) {
    return cluster.words[0].toUpperCase();
  }

  onFileNotFound($event, keywordObj) {
    if (!keywordObj.fileNotFound) {
      $event.target.src = this.fileNotFoundImage;
      keywordObj.fileNotFound = true;
    }
  }

  get fileNotFoundImage() {
    return this.assetsPipe.transform('image/not-found.png');
  }

  editPicture(keywordObj) {
    const modalRef = this.modalService.open(
      SearchPixabayPictureModalComponent,
      { size: 'lg', windowClass: 'big-modal' },
    );
    modalRef.componentInstance.setSearchText(this.getCurrentWord(keywordObj));

    modalRef.result.then(result => {
      if (result) {
        keywordObj.overrideImage = result;
        keywordObj.fileNotFound = false;
      }
    });
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  isOverridenWord(keywordObject) {
    return keywordObject.overrideWord;
  }

  isOverridenImage(keywordObject) {
    return keywordObject.overrideImage;
  }

  onSelectCluster(cluster: any) {
    this.selectedCluster = cluster;
    const overrideWords = cluster['override_words'] || [];
    const overrideImages = cluster['override_urls'] || [];

    this.keywordObjects = cluster['words'].map((word, index) => {
      return {
        originalWord: word,
        originalImage: cluster['urls'][index],
        overrideWord: overrideWords[index],
        overrideImage: overrideImages[index],
        selectedImage: null,
        editing: false,
        fileNotFound: false,
      };
    });
  }

  resetOriginalKeyword(keywordObj) {
    keywordObj.overrideWord = null;
  }

  resetOriginalImage(keywordObj: any) {
    keywordObj.overrideImage = null;
  }

  getCurrentWord(keywordObj: any) {
    if (keywordObj.overrideWord) {
      return keywordObj.overrideWord;
    } else {
      return keywordObj.originalWord;
    }
  }

  getCurrentImage(keywordObj: any) {
    if (keywordObj.overrideImage) {
      return keywordObj.overrideImage;
    } else {
      return keywordObj.originalImage;
    }
  }

  _saveChanges() {
    const overrideWords = this.keywordObjects.map(
      keywordObject => keywordObject['overrideWord'],
    );
    const overrideUrls = this.keywordObjects.map(keywordObject => {
      if (keywordObject['overrideImage']) {
        return keywordObject['overrideImage'];
      } else {
        return null;
      }
    });

    this.requestInProgress = true;

    return this.topicvizService.updateClusterMetaData({
      clusteredCollectionId: this.selectedCluster['clustered_collection_id'],
      overrideUrls: overrideUrls,
      overrideWords: overrideWords,
      topicIndex: this.selectedCluster['cluster_index'],
    });
  }

  save() {
    this._saveChanges().subscribe(
      () => {
        this.requestInProgress = false;
        this.hasChanges = true;
      },
      () => {
        this.requestInProgress = false;
        alert('something went wrong');
      },
    );
  }

  saveAndClose() {
    this._saveChanges().subscribe(
      () => {
        this.requestInProgress = false;
        this.hasChanges = true;
        this.close();
      },
      () => {
        this.requestInProgress = false;
        alert('something went wrong');
      },
    );
  }

  close() {
    this.activeModal.close(this.hasChanges);
  }
}
